import React from 'react'
import { Grid } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const filterInputRows = (inputRows: React.ReactElement[][]) =>
  inputRows.filter(row => {
    return !row.every(element => element === (undefined || null))
  })

export interface InputGroupProps {
  inputRows: React.ReactElement[][]
}

const defaultSx = {
  padding: 0,
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.07)',
}

const InputGroup: React.FC<InputGroupProps> = ({ inputRows }) => {
  const filteredInputRows = filterInputRows(inputRows)

  const theme = useTheme()
  return (
    <Grid container direction='column' spacing={0} sx={defaultSx}>
      {filteredInputRows.length &&
        filteredInputRows.map((row, rowIndex) => (
          <Grid item key={rowIndex} container>
            {row.map((input, fieldIndex) => {
              const isFirstRow = rowIndex === 0
              const isLastRow = rowIndex === filteredInputRows.length - 1
              const isFirstField = fieldIndex === 0
              const isLastField = fieldIndex === row.length - 1

              const style = {
                border: '1px solid rgba(0, 0, 0, 0.2)',
                marginBottom: 0,
                paddingBottom: 0,
                fieldSet: {
                  borderRadius: 0,
                  boxShadow: 'none',
                  border: '1px solid transparent',
                  borderTopLeftRadius: isFirstRow && isFirstField ? 8 : 0,
                  borderTopRightRadius: isFirstRow && isLastField ? 8 : 0,
                  borderBottomLeftRadius: isLastRow && isFirstField ? 8 : 0,
                  borderBottomRightRadius: isLastRow && isLastField ? 8 : 0,
                },
                borderTopLeftRadius: isFirstRow && isFirstField ? 8 : 0,
                borderTopRightRadius: isFirstRow && isLastField ? 8 : 0,
                borderBottomLeftRadius: isLastRow && isFirstField ? 8 : 0,
                borderBottomRightRadius: isLastRow && isLastField ? 8 : 0,
                borderTop: !isFirstRow ? 0 : '1px solid rgba(0, 0, 0, 0.2)',
                borderRight: isLastField ? '' : 'none',
                boxShadow: 'none',
                formControl: {
                  marginBottom: 0,
                  height: theme.spacing(5.25),
                },
              }

              const inputComponent = React.cloneElement(input, {
                key: fieldIndex,
                sx: { ...input.props.sx, ...style },
              })

              return (
                <Grid
                  item
                  xs={input.props.width || 12}
                  key={fieldIndex}
                  sx={{ padding: 0 }}
                >
                  {inputComponent}
                </Grid>
              )
            })}
          </Grid>
        ))}
    </Grid>
  )
}

export default InputGroup
